import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "flush"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { StyledMultiColumnSection } from './MultiColumnSection';
import { StyledMultiColumnGroup } from './MultiColumnGroup';
import { ItemContainer } from './MultiColumnItem';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledMultiColumn = styled.div.withConfig({
  displayName: "MultiColumn__StyledMultiColumn",
  componentId: "sc-16wywe7-0"
})(["background-color:", ";border:", ";border-radius:", ";width:100%;", " @media only screen and (min-width:576px){display:table;> ", ":first-child > ", ",> ", ":first-child > ", " > ", "{border-color:", ";}", "}@media only screen and (max-width:calc(576px - 1px)){> div:first-child{border-color:", ";}> div > div{border-color:", ";width:100% !important;}", "}", ";"], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => `${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']}`, ({
  theme
}) => `${theme.borderRadius['transitional-container']}`, props => props.$flush && `
    border-color: ${props.theme.color['fill-transparent-default']};

    > ${StyledMultiColumnGroup}:first-child > ${ItemContainer},
    > ${StyledMultiColumnSection}:first-child > ${StyledMultiColumnGroup} > ${ItemContainer} {
      padding-top: 0;
    }

    > ${StyledMultiColumnGroup}:last-child > ${ItemContainer},
    > ${StyledMultiColumnSection}:last-child > ${StyledMultiColumnGroup} > ${ItemContainer} {
      padding-bottom: 0;
    }
  `, StyledMultiColumnGroup, ItemContainer, StyledMultiColumnSection, StyledMultiColumnGroup, ItemContainer, ({
  theme
}) => theme.color['fill-transparent-default'], props => props.$flush && `
      > ${StyledMultiColumnGroup} > ${ItemContainer}:first-child,
      > ${StyledMultiColumnSection} > ${StyledMultiColumnGroup} > ${ItemContainer}:first-child {
        padding-inline-start: 0;
      }

      > ${StyledMultiColumnGroup} > ${ItemContainer}:last-child,
      > ${StyledMultiColumnSection} > ${StyledMultiColumnGroup} > ${ItemContainer}:last-child {
        padding-inline-end: 0;
      }
    `, ({
  theme
}) => theme.color['fill-transparent-default'], ({
  theme
}) => theme.color['fill-transparent-default'], props => props.$flush && `

      > ${StyledMultiColumnGroup} > ${ItemContainer}:last-child,
      > ${StyledMultiColumnSection} > ${StyledMultiColumnGroup} > ${ItemContainer}:last-child {
        padding-inline-end: 0;
      }

      > ${StyledMultiColumnGroup} > ${ItemContainer}:first-child,
      > ${StyledMultiColumnSection} > ${StyledMultiColumnGroup} > ${ItemContainer}:first-child {
        padding-inline-start: 0;
      }
    `, ({
  $cssStyles
}) => $cssStyles);
export const MultiColumn = _ref => {
  let {
      children,
      flush = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledMultiColumn, Object.assign({
    $flush: flush
  }, domProps, {
    $cssStyles: cssStyles,
    children: children
  }));
};
MultiColumn.displayName = 'MultiColumn';